module.exports = __webpack_public_path__ + "static/media/pink-vest.e7af1474.jpg";